import { render, staticRenderFns } from "./ServicesPanel.vue?vue&type=template&id=12f7983b&"
import script from "./ServicesPanel.vue?vue&type=script&lang=js&"
export * from "./ServicesPanel.vue?vue&type=script&lang=js&"
import style0 from "./ServicesPanel.vue?vue&type=style&index=0&id=12f7983b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports